module.exports = __webpack_public_path__ + "img/Home_hoch.5aee6657.jpg";